import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import type HotelDayByDaySpiderDashboardController from 'lumen/controllers/hotel/day-by-day/spider-dashboard';
import contextualPageTitle from 'lumen/helpers/contextual-page-title';
import getEnv from 'lumen/helpers/get-env';

interface HotelDayByDaySpiderDashboardSignature {
  Args: {
    controller: HotelDayByDaySpiderDashboardController;
    model: unknown;
  };
}

<template>
  {{pageTitle (contextualPageTitle (t "menu.spider.day-by-day"))}}

  <GeneralEmbeddedApp
    {{! @glint-expect-error: Incorrect type }}
    @baseURL={{getEnv "spiderIframeURL"}}
    @id="spider-day-by-day"
    @query={{@controller.iframeQPs}}
    @url={{@controller.urlForEmbeddedApp}}
  />
</template> satisfies TOC<HotelDayByDaySpiderDashboardSignature>;
